module.exports = function({ addComponents, theme }) {
  const buttons = {
    '.btn': {
      borderRadius: theme('borderRadius.md'),
      fontFamily: theme('fontFamily.base'),
      fontWeight: theme('fontWeight.regular'),
      display: 'inline-block',
      'text-align': 'center',
      cursor: 'pointer',

      '&:disabled': {
        color: theme('colors.neutral.medium'),
      },

      '&-container': {
        display: 'flex',
        gap: theme('spacing.xxs'),
        margin: 'auto',
        justifyContent: 'center',
        flexDirection: 'column-reverse',

        [`@media (min-width: ${theme('screens.sm')})`]: {
          flexDirection: 'row',
        },
      },

      '&-primary': {
        backgroundColor: theme('colors.brand-secondary.dark'),
        color: theme('colors.neutral.white'),
        '&:hover': {
          backgroundColor: theme('colors.brand-secondary.lightest'),
          color: theme('colors.neutral.white'),
        },
        '&:disabled': {
          backgroundColor: theme('colors.neutral.light'),
        },
        '.btn-container &': {
          width: '100%',
          [`@media (min-width: ${theme('screens.sm')})`]: {
            width: 'fit-content',
          },
        },
        '.fotocasa &': {
          backgroundColor: theme('colors.fotocasa.primary'),
          fontWeight: theme('fontWeight.bold'),
        },
      },
      '&-brand': {
        backgroundColor: theme('colors.brand-primary.main'),
        color: theme('colors.neutral.ultradark'),
        '&:hover': {
          backgroundColor: theme('colors.brand-primary.soft'),
          color: theme('colors.neutral.ultradark'),
        },
      },
      '&-secondary': {
        backgroundColor: 'transparent',
        borderWidth: theme('borderWidth.thin'),
        color: theme('colors.brand-secondary.dark'),
        boxSizing: 'border-box',
        borderColor: theme('colors.brand-secondary.dark'),

        '&:hover': {
          borderColor: theme('colors.brand-secondary.lightest'),
          color: theme('colors.brand-secondary.lightest'),
        },
        '&:disabled': {
          borderColor: theme('colors.neutral.medium'),
          color: theme('colors.neutral.medium'),
        },
        '.fotocasa &': {
          fontWeight: theme('fontWeight.bold'),
        },
      },
      '&-ghost': {
        backgroundColor: 'transparent',
        borderWidth: theme('borderWidth.thin'),
        color: theme('colors.brand-secondary.dark'),
        boxSizing: 'border-box',
        borderColor: 'transparent',

        '&:hover': {
          color: theme('colors.brand-secondary.lightest'),
        },

        '.fotocasa &': {
          color: theme('colors.fotocasa.primary'),
        },
      },
      '&-link': {
        background: 'url(/img/web/icons/link.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        padding: `${theme('spacing.xxs')}`,
        position: 'relative',
        borderWidth: theme('borderWidth.hairline'),
        boxSizing: 'border-box',
        borderRadius: theme('borderRadius.circular'),
        borderColor: theme('colors.neutral.light'),

        '&:hover': {
          cursor: 'pointer',
        },
      },
      '&-sm': {
        padding: `${theme('spacing.quark')} ${theme('spacing.nano')}`,
        'min-width': '10rem',
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.nano'),
      },
      '&-md': {
        padding: `${theme('spacing.nano')} ${theme('spacing.xxxs')}`,
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.xs'),
      },
      '&-lg': {
        padding: `${theme('spacing.xxxs')} ${theme('spacing.xxs')}`,
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.sm'),

        '.fotocasa &': {
          padding: `${theme('spacing.nano')} ${theme('spacing.xs')}`,
          fontSize: '15px',
        },
      },
      '&-social': {
        display: 'flex',
        width: '100%',
        padding: `${theme('spacing.micro')} 0`,
        borderRadius: theme('borderRadius.md'),
        justifyContent: 'center',
        gap: theme('spacing.xxxs'),
        backgroundColor: theme('colors.neutral.lightest'),
        color: theme('colors.neutral.semidark'),
      },
    },
  };

  addComponents(buttons, ['responsive']);
};
